import moment from 'moment';

export const getDateTimeStringOrUndefined = (date) => {
  return date ? moment(date).toISOString() : undefined;
};

export const formatDate = (date) => {
  return date ? moment(date).format('DD/MM/YYYY') : '';
};
